import React, {Component} from 'react';
import {Modal} from 'antd';
import Form from "./RoomForm";

export default class ChangeCategory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
        this.content = [
            {
                name: '房间种类名',
                type: 'input',
                dataIndex: 'name',
                labelCol: 8,
                required:true,
                wrapperCol: 14,
                message:'请填写房间种类名'
            },
            {
                name: '房间种类叙述',
                type: 'textarea',
                dataIndex: 'describe',
                labelCol: 8,
                required:true,
                wrapperCol: 14,
                message:'请填写房间种类叙述'
            },
            {
                name: '排序',
                type: 'input',
                dataIndex: 'sequence',
                labelCol: 8,
                required:true,
                wrapperCol: 14,
                message:'请排序'
            },
            // {
            //     name: '房间封面图',
            //     type: 'image',
            //     dataIndex: 'photos',
            //     required: true,
            //     message: '请上传房间种类图片',
            //     labelCol: 8,
            //     wrapperCol: 14,
            // },
            {
                name: '房间种类内容介绍图',
                type: 'image',
                dataIndex: 'photos',
                required: true,
                message: '请上传房间种类内容介绍图',
                labelCol: 8,
                wrapperCol: 14,
            },
            {
                name: '是否展示',
                type: 'select',
                dataIndex: 'status',
                labelCol: 8,
                required: true,
                wrapperCol: 14,
                message: '请选择是否展示',
                option: [
                    {id: 1, name: '展示'},
                    {id: 2, name: '不展示'}
                ]
            },
        ]
    }

    onSubmit = () => {
        this.props.refreshList();
        this.setState({
            visible: false
        })
    }
    handleCancel = () => {
        this.setState({
            visible: false
        })
    }

    render() {

        return (
            <>
                <a onClick={() => {
                    this.setState({visible: true})
                }}>编辑信息</a>
                <Modal
                    // width={window.innerWidth * 0.8}
                    title="编辑信息"
                    visible={this.state.visible}
                    footer={null}
                    destroyOnClose={true}
                    onCancel={this.handleCancel}
                >
                    <Form
                        content={this.content} onSubmit={this.onSubmit} url={'/api/room/category/save'}
                        imageDataIndex={'photos'}
                        values={this.props.item}
                        tags={'tag'}
                        value={{id: this.props.item.id}}
                        checkNumber={true}
                    />
                </Modal>
            </>
        );
    }
}
